import type { FC } from "react";
import type { UseFormReturn } from "../common/form/useForm";
import { ExtraForm } from "../common/pure/ExtraFormGroup";
import type { FormMyBusinessLocationFields } from "./FormBusinessLocationFields";
import { PHONE_COUNTRY_CODES } from "./phoneCountries";

type Props = {
	form: UseFormReturn<FormMyBusinessLocationFields>;
};

export const FormBusinessContactLocation: FC<Readonly<Props>> = ({ form }) => {
	return (
		<>
			<ExtraForm.Group label="Public name">
				<ExtraForm.Control
					type="text"
					placeholder="Public name"
					{...form.getFieldProps("title")}
					{...form.getFieldState("title")}
				/>
			</ExtraForm.Group>
			<ExtraForm.Group label="Legal name">
				<ExtraForm.Control
					type="text"
					placeholder="Legal / registered business name"
					{...form.getFieldProps("legalName")}
					{...form.getFieldState("legalName")}
				/>
			</ExtraForm.Group>
			<ExtraForm.Group label="Description">
				<ExtraForm.Control
					as="textarea"
					rows={3}
					placeholder="Description"
					{...form.getFieldProps("description")}
					{...form.getFieldState("description")}
				/>
			</ExtraForm.Group>
			<ExtraForm.Group label="Phone Number">
				<div
					style={{
						display: "flex",
						gap: 8,
						alignItems: "flex-start",
					}}
				>
					<ExtraForm.Select
						aria-label="Country code"
						style={{ maxWidth: 200, flexShrink: 0 }}
						{...form.getFieldProps("phoneCountryCode")}
						{...form.getFieldState("phoneCountryCode")}
					>
						{PHONE_COUNTRY_CODES.map((c) => (
							<option key={`${c.iso}-${c.dial}`} value={c.dial}>
								{c.label}
							</option>
						))}
					</ExtraForm.Select>
					<ExtraForm.Control
						type="tel"
						placeholder="Phone number"
						style={{ flex: 1 }}
						{...form.getFieldProps("phone")}
						{...form.getFieldState("phone")}
					/>
				</div>
			</ExtraForm.Group>
			<ExtraForm.Group label="Website">
				<ExtraForm.Control
					type="text"
					placeholder="Website"
					{...form.getFieldProps("websiteUri")}
					{...form.getFieldState("websiteUri")}
				/>
			</ExtraForm.Group>
			<ExtraForm.Group label="Street">
				<ExtraForm.Control
					type="text"
					placeholder="Street"
					{...form.getFieldProps("street")}
					{...form.getFieldState("street")}
				/>
			</ExtraForm.Group>
			<ExtraForm.Group label="City">
				<ExtraForm.Control
					type="text"
					placeholder="City"
					{...form.getFieldProps("city")}
					{...form.getFieldState("city")}
				/>
			</ExtraForm.Group>
			<ExtraForm.Group label="State or Administrative Area">
				<ExtraForm.Control
					type="text"
					placeholder="State or Administrative Area"
					{...form.getFieldProps("administrativeArea")}
					{...form.getFieldState("administrativeArea")}
				/>
			</ExtraForm.Group>
			<ExtraForm.Group label="Zip">
				<ExtraForm.Control
					type="text"
					placeholder="Zip"
					{...form.getFieldProps("zip")}
					{...form.getFieldState("zip")}
				/>
			</ExtraForm.Group>
		</>
	);
};
